export enum TransactionStatus {
    Initialized = 0,
    Completed = 1,
    Pending = 2,
    Rejected = 3,
    Expired = 4,
    Failed = 5,
    Cancelled  = 6
}


// WEBPACK FOOTER //
// ./src/model/types/wallet-transactionstatus-type.ts